import styled from 'styled-components/macro';

export const Ellipsis = styled.div`
  cursor: pointer;
`;
